import { toast } from 'react-toastify';

interface HandleAsyncActionOptions {
  onSuccessMessage?: string;
  onErrorMessage?: ((error: any) => void) | string;
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
  dispatchAction?: () => void;
  errorLogger?: (error: any) => void;
  displayToastType?: 'error' | 'warning' | 'info' | 'success';
  onPendingMessage?: string;
  showPendingToast?: boolean;
}

export const handleToastAsyncAction = async (
  asyncFn: () => Promise<any>,
  {
    onSuccessMessage,
    onErrorMessage,
    showSuccessToast = true,
    showErrorToast = true,
    dispatchAction,
    errorLogger,
    displayToastType,
    onPendingMessage,
    showPendingToast,
  }: HandleAsyncActionOptions
): Promise<{ success: true; data?: any } | { success: false; error: any }> => {
  toast.clearWaitingQueue();

  try {
    if (showPendingToast && onPendingMessage) {
      toast.info(onPendingMessage);
    }

    const response = await asyncFn();
    if (dispatchAction) dispatchAction();
    if (showSuccessToast && onSuccessMessage) {
      toast.success(onSuccessMessage);
    }
    return { success: true, data: response };
  } catch (error: any) {
    console.error('Async action failed:', error);

    const isClientError =
      error?.response?.status >= 400 && error?.response?.status < 500;

    const message = isClientError
      ? error?.response?.data?.detail || onErrorMessage
      : error?.message || 'Unexpected error';

    if (errorLogger) {
      errorLogger(error);
    }

    if (showErrorToast) {
      const toastFn = displayToastType
        ? toast[displayToastType]
        : isClientError ? toast.warning : toast.error;

      toastFn(message);
    }

    return { success: false, error };
  }
};
